import {
  Icons,
  ChakraText as Text,
  ChakraBox as Box,
  ChakraFlex as Flex,
  ChakraHeading as Heading,
  chakraUseTheme as useTheme,
} from "@airhelp/react-ui-components";
import { motion } from "framer-motion";
import { icons } from "styles/icons";
import type { CardDesktopProps } from "./Card.d";

const MotionFlex = motion(Flex);

const CardDesktop = ({
  heading,
  text,
  subHeading,
  icon,
  openCard,
  setOpenCard,
  cardsHeightDesktop,
}: CardDesktopProps) => {
  const {
    colors: {
      primary: { 500: primary500, 900: primary900 },
      greyscale: { 100: greyscale100, 500: greyscale500 },
    },
  } = useTheme();

  const shouldHoverCard = openCard === heading;

  const cardVariants = {
    hovered: {
      backgroundColor: primary500,
      color: greyscale100,
      height: "auto",
    },
    unhovered: {
      backgroundColor: greyscale100,
      color: primary900,
    },
  };

  const iconVariants = {
    hovered: {
      color: greyscale100,
      y: "-4px",
    },
    unhovered: {
      color: primary500,
      y: "0px",
    },
  };

  const textVariants = {
    hovered: {
      backgroundColor: primary500,
      opacity: 1,
    },
    unhovered: {
      backgroundColor: greyscale100,
      opacity: 0,
    },
  };

  const subHeadingVariants = {
    hovered: {
      color: greyscale100,
    },
    unhovered: {
      color: greyscale500,
    },
  };

  const handleSetOpenCard = () => setOpenCard(heading);

  const Icon = Icons[icon] || icons[icon];

  return (
    <MotionFlex
      py={10}
      px={8}
      rounded="lg"
      justifyContent="space-between"
      flexDirection="column"
      minHeight={cardsHeightDesktop}
      onMouseEnter={handleSetOpenCard}
      variants={cardVariants}
      borderColor="greyscale.400"
      animate={shouldHoverCard ? "hovered" : "unhovered"}
      initial={shouldHoverCard ? "hovered" : "unhovered"}
      alignItems="flex-start"
    >
      <motion.div variants={iconVariants}>
        <Icon h={10} w={10} mb={6} />
      </motion.div>
      <Box>
        <motion.div variants={subHeadingVariants} layout="position">
          {subHeading && (
            <Text
              color="inherit"
              textTransform="uppercase"
              letterSpacing="1.5px"
              fontWeight="bold"
              textAlign="left"
              mb={4}
              fontSize="xs"
            >
              {subHeading}
            </Text>
          )}
        </motion.div>
        <motion.div layout="position">
          <Heading color="inherit" variant="h4" as="h4" mb={4} textAlign="left">
            {heading}
          </Heading>
        </motion.div>
        <motion.div variants={textVariants} layout>
          {shouldHoverCard && (
            <Text color="white" textAlign="left" fontSize="md">
              {text}
            </Text>
          )}
        </motion.div>
      </Box>
    </MotionFlex>
  );
};

export default CardDesktop;
